<template>
  <div class="pt-5 mt-5 text-center">
    <div><img src="../assets/failOrder.png" /></div>
    <h1 class="mt-2 mb-2" style="font-size:2em">
      <b>Sorry Payment Failed</b>
    </h1>
    <h4 class="mb-5">Please Try Again</h4>
    <a href="/" class="mt-5 btn btn-danger btn-lg">Back to Home</a>
  </div>
</template>

<script>
import { dbFs } from "@/modules/database";
import router from "@/modules/router";
export default {
  data() {
    return {
      orderId: this.$route.params.ORDERID
    };
  },
  mounted() {
    setTimeout(() => {
      this.updateOrder();
    }, 2000);
  },
  methods: {
    updateOrder() {
      dbFs
        .collection("order")
        .doc(this.orderId)
        .delete()
        .then(() => {
          router.push("/");
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
